
//NOTE TO SELF, API for stage uses stagenum, NOT primary key.
//NOTE TO SELF, API often uses itempk in URL. This is item.id, which is NOT an item record itself, but the badge id (item_id column)


//submit rules =
    //parents in chain are submitted (i.e. what if you earn badge elsewhere that is in middle of chain)
    //parent stage has all prereqs met

//connect multiple state stores, use reflux to influence display.
    //show symbols for submitted, assessed, earned


var ProgramExplorer = function(options){
    var oThis = this;

    oThis.defaults = {
        programID: null,
        orgID: null,
        portfolio_user: 0,
        program_role_id: 0,
        view_mode: false
    }

    oThis.settings = $.extend( {}, oThis.defaults, options );

    oThis.apiRoot = buildRoute(mantlroutes.program, { orgid: oThis.settings.orgID, programid: oThis.settings.programID });

    oThis.Actions = Reflux.createActions(['fetchProgram','fetchBadgeDetails','fetchSubmissions','fetchAssessments','fetchEarnedBadges']);
    oThis.containerID;
    oThis.modalsID = "programModals";
    oThis.msgStack = new MessageStack();
    oThis.createStore();

    oThis.handleStack = function(){
        oThis.msgStack.Display(); //should we put these in a program builder container?
        oThis.msgStack.Clear();
    }

    //React components

    //Program Explorer
    oThis.ProgramExplorerViewer = createReactClass({
        mixins: [Reflux.connect(oThis.ProgramStore, 'programstore'), Reflux.connect(oThis.EarnedBadgeStore, 'earnedbadgestore'), Reflux.connect(oThis.SubmissionStore, 'submissionstore'), Reflux.connect(oThis.AssessmentStore, 'assessmentstore')],

        render: function() {
            if(this.state.programstore){
                var stages = [];
                for(var i = 1; i < this.state.programstore.length + 1; i++){
                    var oStage = _.find(this.state.programstore, ['order',i]); //we can't rely on api response being sorted by order value
                    var oNextStage = _.find(this.state.programstore, ['order',i+1]),
                    nNextStageID = 0;
                    if(oNextStage != undefined) {
                        nNextStageID = oNextStage.id;
                    }

                    var aEarned = [],
                        aAssessments = [],
                        aSubmissions = [];

                    if(this.state.earnedbadgestore && this.state.earnedbadgestore.length > 0){
                        aEarned = this.state.earnedbadgestore;
                    }
                    if(this.state.assessmentstore && this.state.assessmentstore.length > 0){
                        aAssessments = this.state.assessmentstore;
                    }
                    if(this.state.submissionstore && this.state.submissionstore.length > 0){
                        aSubmissions = this.state.submissionstore;
                    }

                    stages.push(<oThis.ProgramExplorerStage stage={oStage} key={oStage.id} order={oStage.order} nextstageid={nNextStageID} earned={aEarned} submissions={aSubmissions} assessments={aAssessments} />);
                }

                if(stages.length > 0){
                    return (
                        <div className="program program--explorer">
                            <div id={oThis.modalsID}></div>
                            {stages}
                        </div>
                    );
                } else {
                    //Brand new or empty, has no stages
                    var afterorder = 0;
                    return (
                        <div className="program">
                            <div id={oThis.modalsID}></div>
                            <div className="alert alert--information"><h3>This Program is Empty</h3><p>There are no badges to submit to in this program.</p></div>
                        </div>
                    );
                }

            } else {
                return (
                    <div className="program"><div className="spinner spinner--pulsing"><div className="spinner-ring"></div></div></div>
                );
            }

        }
    });

    //Stage
    oThis.ProgramExplorerStage = createReactClass({

        componentDidMount: function() {
            var stage = $(ReactDOM.findDOMNode(this));
            var oComponent = this;
            dragscroll( stage.find(".program-stage")[0] );
            var $description = $(".program-stage[data-order=" + this.props.order + "] .program-stage-description");
        },

        render: function() {
            var oComponent = this;
            var chains = [];
            var addStage, prereqs;
            var missing = 0;

            this.props.stage.prerequisites.forEach(function(element,index){
                if(oThis.settings.view_mode) {
                    if(!element.earned) {
                        missing++;
                    }
                } else if(_.find(oComponent.props.earned,['badge_id',element.item.id]) == undefined ) {
                    missing++;
                }
            });
            // props.earned = earnedbadgestore (kinda gross that we repetitively pass along big blocks of data as props)
            // this gen 1 old style react needs to be replaced. Will patch up until we can rebuild in Next.js environment
            for(var i = 1; i < this.props.stage.chains.length + 1; i++){
                var oChain = _.find(this.props.stage.chains, ['order',i]); //we can't assume api response being sorted by order value
                chains.push(<oThis.ProgramExplorerChain chain={oChain} root={0} key={`stage_${this.props.stage.id}_node_0_chain_${i}`} stageid={this.props.stage.id} nextstageid={this.props.nextstageid} missing={missing} earnedparent={true} earned={this.props.earned} assessments={this.props.assessments} submissions={this.props.submissions} />); //treating root 0 like null
            }
            if (this.props.order > 1) {
                prereqs = <oThis.ProgramExplorerStagePrerequisites stage={this.props.stage} missing={missing} />;
            } else {
                prereqs = null;
            }

            var stageClasses = (missing > 0) ? "program-stage program-stage--locked" : "program-stage";

            return (
                <div className="program-stage-wrapper">
                    {prereqs}
                    <section className={stageClasses} data-order={this.props.order} data-id={this.props.stage.id}>
                        <p><span className="flag program-stage-number"><i className="icon-cube"></i> Program Stage {this.props.stage.order}</span> <span className="program-stage-description">{this.props.stage.description}</span></p>
                        <ul className="program-badges">{chains}</ul>
                    </section>
                </div>
            );
        }
    });

    //Chain of Badge Nodes
    //nodes are program items in database
    oThis.ProgramExplorerChain = createReactClass({

        render: function() {
            var childnodes = [];
            var oRoot;

            if(this.props.chain.nodes != null && this.props.chain.nodes.length > 0){
                //root prop is set to 0 when building a chain at the root of a stage
                if(this.props.root == 0) {
                    //the node with null prerequisite is the root
                    oRoot = _.find(this.props.chain.nodes, ['prerequisite',null]);
                } else {
                    oRoot = _.find(this.props.chain.nodes, ['id',this.props.root]);
                }
            }

            //Check if badge earned
            //props.earned = list of assertions
            var bEarned = false;
            if(this.props.earned.length > 0){
                var earned = _.find(this.props.earned, {'badge_id': oRoot.item.id, 'revoked': null });
                if(earned != undefined){
                    bEarned = true;
                }
            }
            //Check if earned badge was ever revoked
            //there may be assertions that are valid, but we want to at least know if there's a revoked instance
            var wasRevoked = _.find(this.props.earned, function(o) { return o.badge_id == oRoot.item.id && o.revoked != null; }) != undefined;

            if(oThis.settings.view_mode) {
                if(typeof(oRoot.earned) != 'undefined') {
                    bEarned = oRoot.earned;
                } else {
                    var earned = _.find(this.props.assessments, function(o) { return o.submission.badge.id == oRoot.item.id && typeof(o.assertion) != 'undefined'; });
                    if(earned != undefined){
                        bEarned = true;
                    }
                }
            }

            if(this.props.chain.nodes != null && this.props.chain.nodes.length > 0){
                for(var i = 0; i < this.props.chain.nodes.length; i++){
                    var oNode = this.props.chain.nodes[i];
                    if (oNode.prerequisite == oRoot.id){
                        childnodes.push(<oThis.ProgramExplorerChain chain={this.props.chain} root={oNode.id} key={`stage_${this.props.stageid}_node_${oNode.id}_chain_${this.props.chain.order}`} stageid={this.props.stageid} nextstageid={this.props.nextstageid} missing={this.props.missing} earnedparent={bEarned}
                            earned={this.props.earned} assessments={this.props.assessments} submissions={this.props.submissions} />);
                    }
                }
            }

            var aAssessments = [];
            if(this.props.assessments.length > 0){
                aAssessments = _.filter(this.props.assessments, function(assessment) { return assessment.submission.badge.id == oRoot.item.id; });
            }
            var aSubmissions = [];
            if(this.props.submissions.length > 0){
                aSubmissions = _.filter(this.props.submissions, function(submission) { return submission.badge.id == oRoot.item.id; });
            }
            var aPendingAssessments = [];
            if(this.props.submissions.length > 0){
                aPendingAssessments = _.filter(this.props.submissions, function(submission) { return submission.assessment_url == null && submission.badge.id == oRoot.item.id; });
            }

            if(childnodes.length > 0){
                return (
                    <li>
                        <oThis.ProgramExplorerBadge stageid={this.props.stageid} nodes={this.props.chain.nodes} itemurl={oRoot.url} submiturl={oRoot.submit_url} badge={oRoot.item} nextstageid={this.props.nextstageid} stagelocked={this.props.missing > 0}
                            library={false} earnedparent={this.props.earnedparent} earned={bEarned} wasRevoked={wasRevoked} assessments={aAssessments} submissions={aSubmissions} pending={aPendingAssessments}  />
                        <ul className="program-badges">
                            {childnodes}
                        </ul>
                    </li>
                );
            } else {
                return (
                    <li>
                        <oThis.ProgramExplorerBadge stageid={this.props.stageid} nodes={this.props.chain.nodes} itemurl={oRoot.url} submiturl={oRoot.submit_url} badge={oRoot.item} nextstageid={this.props.nextstageid} stagelocked={this.props.missing > 0}
                            library={false} earnedparent={this.props.earnedparent} earned={bEarned} wasRevoked={wasRevoked} assessments={aAssessments} submissions={aSubmissions} pending={aPendingAssessments} />
                    </li>

                );
            }

        }
    });


    //Badge Card
    oThis.ProgramExplorerBadge = createReactClass({
        handleFlip: function(e) {
            e.stopPropagation();
            var $badge = $(ReactDOM.findDOMNode(this));
            $badge.toggleClass("is-flipped");
            if( $badge.hasClass("is-flipped")){
                oThis.Actions.fetchBadgeDetails(this.props.badge.id, $badge);
            }
        },

        handleHighlight: function() {
            var $badge = $(ReactDOM.findDOMNode(this));
            var bLibrary = this.props.library || false;
            if(bLibrary) {
                $badge.closest(".modal").find(".badge--highlighted").removeClass("badge--highlighted");
                $badge.addClass("badge--highlighted");
            }
        },

        handleSubmit: function(e) {
            //Build Modal
            e.preventDefault();
            httpGet(this.props.submiturl).then(
                function(value) {
                    var response = value;

                    var $modal = buildModal(response,{
                        classes: 'modal modal--full',
                        header: "Submit Evidence for Badge"
                    });
                    $('body').append($modal);
                    $modal.on("modal:close",function(){
                        $modal.off("modal:close").remove();
                        oThis.Actions.fetchSubmissions();
                    })
                    $modal.openModal();
                })
            .catch(
                function(reason) {
                    console.error('Error loading badge submit.', reason);
                    alertify.error('Unable to Open Submit Modal')
                });
        },

        handleViewDetails: function(e) {
            //Build Modal
            e.preventDefault();
            httpGet(this.props.itemurl).then(
                function(value) {
                    var response = value;

                    var $modal = buildModal(response,{
                        classes: 'modal modal--full',
                        header: "Program Item Details"
                    });
                    $('body').append($modal);
                    $modal.on("modal:close",function(){
                        $modal.off("modal:close").remove();
                    })
                    $modal.openModal();
                })
            .catch(
                function(reason) {
                    console.error('Error loading item details.', reason);
                    alertify.error('Unable to Open Program Item')
                });
        },

        componentDidMount: function() {
            var $badge = $(ReactDOM.findDOMNode(this));
            var oComponent = this;

            if(!this.props.library){
                $badge.addClass("animated boingInUp");
            }
            setTimeout(function(){ $badge.removeClass("animated boingInUp"); },1100);

            $badge.on('change','.switch',function(){
                var bIsOn = $(this).prop( "checked" );
                oComponent.handleSwitch(bIsOn);
            });
            $('[data-popover="tooltip"]',ReactDOM.findDOMNode(this)).tooltip();
        },

        componentDidUpdate: function() {
            //reset the badge
            var $badge = $(ReactDOM.findDOMNode(this));
            $badge.removeClass("is-flipped").find(".badge-back-content").empty();
            $(".badge--highlighted").removeClass("badge--highlighted");
            $('[data-popover="tooltip"]',ReactDOM.findDOMNode(this)).tooltip();
        },

        render: function() {
            var oComponent = this;
            var nextstageid = this.props.nextstageid || 0;
            var bLibrary = this.props.library || false;
            var bCanDelete = false;
            var prerequisite = null;
            if(this.props.nodes){
                prerequisite = _.find(this.props.nodes, function(a) { return a.item.id == oComponent.props.badge.id; }).prerequisite || null;
            }
            var checkbox = "prereqswitch_" + this.props.badge.id; //important, this prereq is for the next stage, which uses badge PKs, not program item PKs (but "item" in the node refers to a badge record)
            var bIsPrereq = false;
            var oNextStage = _.find(oThis.ProgramStore.program, ['id',nextstageid]);
            if(oNextStage != undefined) {
                if(oNextStage.prerequisites != undefined && oNextStage.prerequisites.length > 0) {
                    for(var i = 0; i < oNextStage.prerequisites.length; i++) {
                        if(oNextStage.prerequisites[i].item.id == this.props.badge.id){
                            bIsPrereq = true;
                        }
                    }
                }
            }

            var aMetCriteria = [];
            this.props.assessments.forEach(function(element,index){
                aMetCriteria = aMetCriteria.concat(element.criteria);
            });
            var aUnique = _.uniqBy(aMetCriteria, 'id');
            var classes = (this.props.earned) ? "badge badge--earned" : "badge";
            classes += (aUnique.length > 0 && !this.props.earned) ? " badge--partial" : "";
            // console.table(this.props);
            //console.info('badge', this.props.badge, 'aUnique', aUnique, 'aMetCriteria', aMetCriteria, 'earned', this.props.earned, 'classes', classes);

            return (
                <figure className={classes} data-badge-id={this.props.badge.id} data-badge-details={this.props.badge.url} onClick={this.handleHighlight}>
                    <div className="badge-face badge-front">
                        <figcaption className="badge-name">{this.props.badge.name}</figcaption>
                        {(function(){
                            if (oComponent.props.earned) {
                                return (<span className="badge-flag--earned" data-popover="tooltip" title="Badge Earned"><i className="icon-star"></i></span>);
                            }
                            if (oComponent.props.wasRevoked) {
                                return (<span className="badge-flag--revoked" data-popover="tooltip" title="Badge Was Revoked"><i className="icon-remove"></i></span>);
                            }
                            if (!oComponent.props.earned && aUnique.length > 0) {
                                return (<span className="badge-flag--partial" data-popover="tooltip" title="Badge Partially Earned"><i className="icon-star-half-full"></i></span>);
                            }
                        })()}
                        <button className="badge-flip" title="See Details" onClick={this.handleFlip}><i className="icon-rotate-left"></i></button>
                        <img className="badge-art" src={this.props.badge.image} title="Badge Art"></img>
                        <p className="badge-flags">
                            {(function(){
                                if (nextstageid != 0 && bIsPrereq && !bLibrary) {
                                    return (<span className="badge-flag badge-flag--prerequisite" data-popover="tooltip" data-delay="750" title="Prerequisite for Next Stage"><i className="icon-key icon--secondary"></i></span>);
                                }
                            })()}
                            {/* <span className="badge-flag" data-popover="tooltip" data-delay="250" title="Submissions Made">{this.props.submissions.length}</span> */}
                            <span className="badge-flag" data-popover="tooltip" data-delay="250" title="Met Criteria"><i className="icon-check-circle-o icon--success"></i> {aUnique.length}</span>
                            <span className="badge-flag" data-popover="tooltip" data-delay="250" title="Submissions Awaiting Assessment"><i className="icon-clock-o icon--success"></i> {this.props.pending.length}</span>
                            {(function(){
                                if (!oComponent.props.earned && oComponent.props.earnedparent && !oComponent.props.stagelocked && !oThis.settings.view_mode) {
                                    if(oComponent.props.pending.length > 0){
                                        return (<a className="button button--sm button--warning button--skinny" data-popover="tooltip" data-delay="250" title="Submitted. Awaiting Assessment"><i className="icon-clock-o"></i> Pending</a>);
                                    } else {
                                        return (<a className="button button--sm button--success button--skinny" onClick={oComponent.handleSubmit} href={oComponent.props.submiturl}><i className="icon-cloud-upload"></i> Submit</a>);
                                    }

                                } else if ((!oComponent.props.earned && !oComponent.props.earnedparent) || oComponent.props.stagelocked && !oThis.settings.view_mode) {
                                    return (<a className="button fubar button--sm button--error button--skinny" disabled data-popover="tooltip" data-delay="250" title="Requirements Not Met"><i className="icon-close"></i> Submit</a>);
                                }
                            })()}
                        </p>
                        {/* <span className="flag badge-id" title="Badge ID">{this.props.badge.id}</span> */}
                    </div>
                    <div className="badge-face badge-back">
                        <button className="badge-flip" onClick={this.handleFlip} title="Hide Details"><i className="icon-rotate-right"></i></button>
                        <div className="badge-back-content">
                            <div className="spinner spinner--pulsing"><div className="spinner-ring"></div></div>
                        </div>
                        <p className="text--loosetop"><a className="button button--sm button--pill button--skinny" onClick={oComponent.handleViewDetails} href={oComponent.props.itemurl}><i className="icon-info"></i> Item Details</a></p>
                    </div>

                </figure>
            );

        }
    });


    //Stage Prereqs
    oThis.ProgramExplorerStagePrerequisites = createReactClass({

        handleClick: function(e) {

        },

        componentDidMount: function() {
            var $prereq = $(ReactDOM.findDOMNode(this))
            var aPrereqs = this.props.stage.prerequisites;
            $prereq.tooltip();
            $prereq.on('mouseenter',function(){
                $prereq.tooltip();
                for(var i = 0; i < aPrereqs.length; i++){
                    $(".badge[data-badge-id=" + aPrereqs[i].item.id + "]").addClass("animated animated--infinite pulse badge--highlighted");
                }
            }).on('mouseleave',function(){
                $(".badge.badge--highlighted").removeClass("animated animated--infinite pulse badge--highlighted");
            });
        },

        componentDidUpdate: function() {
            var $prereq = $(ReactDOM.findDOMNode(this));
            var aPrereqs = this.props.stage.prerequisites;
            $prereq.on('mouseenter',function(){
                $prereq.tooltip();
                for(var i = 0; i < aPrereqs.length; i++){
                    $(".badge[data-badge-id=" + aPrereqs[i].item.id + "]").addClass("animated animated--infinite pulse badge--highlighted");
                }
            }).on('mouseleave',function(){
                $(".badge.badge--highlighted").removeClass("animated animated--infinite pulse badge--highlighted");
            });
        },

        componentWillUnmount: function() {
        },

        render: function() {
            var oComponent = this;
            var sID = "prereqs_" + this.props.stage.id;

            if(this.props.stage.prerequisites != undefined && this.props.stage.prerequisites.length > 0 && this.props.missing > 0) {
                return (<div className="program-stage-prerequisites program-stage-prerequisites-missing" id={sID} data-stage={this.props.stage.id} data-popover="tooltip" data-placement="right" title={"Missing " + this.props.missing + " Stage Prerequisites"}><i className="icon-lock"></i></div>);
            } else if(this.props.stage.prerequisites != undefined && this.props.stage.prerequisites.length > 0 && this.props.missing == 0){
                return (<div className="program-stage-prerequisites" id={sID} data-stage={this.props.stage.id} data-popover="tooltip" data-placement="right" title="Met Stage Prerequisites"><i className="icon-unlock icon--success"></i></div>);
            } else {
                return (<div className="program-stage-prerequisites" id={sID} data-stage={this.props.stage.id} data-popover="tooltip" data-placement="right" title="No Stage Prerequisites"><i className="icon-check icon--success"></i></div>);
            }

        }
    });


};

ProgramExplorer.prototype.renderItems = function(containerID) {
    this.containerID = containerID;
    ReactDOM.render(<this.ProgramExplorerViewer />, document.getElementById(this.containerID));
}

//REFLUX STORE
ProgramExplorer.prototype.createStore = function() {
    var oThis = this;

    //mixins: [Reflux.connect(oThis.ProgramStore, 'programstore'),Reflux.connect(oThis.SubmissionStore, 'submissionstore'),Reflux.connect(oThis.AssessmentStore, 'assessmentstore'),,Reflux.connect(oThis.EarnedBadgeStore, 'earnedbadgestore')],

    oThis.ProgramStore = Reflux.createStore({
        listenables: oThis.Actions,
        program: {}, //program items

        init: function() {
            //this.onFetchProgram();
        },

        getInitialState: function() {
            //return this.program;
            this.onFetchProgram();
        },

        onFetchProgram: function() {

            var oStore = this;
            var endpoint = buildRoute(mantlroutes.program_items,{ orgid: oThis.settings.orgID, programid: oThis.settings.programID });
            if(oThis.settings.view_mode && oThis.settings.program_role_id > 0) {
                endpoint += formatParams({ learner: oThis.settings.program_role_id });
            }
            httpGet(endpoint).then(
                function(value) {
                    //console.log(JSON.parse(value))
                    oStore.program = JSON.parse(value);
                    oStore.trigger(oStore.program);
                })
            .catch(
                function(reason) {
                    console.error('Error loading program items.', reason);
                });

        },

        onFetchBadgeDetails: function(nBadgeID, $badge) {
            //console.log("fetch details for " + nBadgeID)
            var $badge = $badge || $(".badge[data-badge-id="+nBadgeID+"]");
            var $backContent = $badge.find(".badge-back-content");

            httpGet(buildRoute(mantlroutes.api_badge,{ badgeid: nBadgeID })).then(
                function(value){
                    value = JSON.parse(value);
                    //console.log(value);
                    $backContent.empty();
                    if(value.description.length == 0){
                        $backContent.append($("<p>").addClass("badge-description").html("<i>No description.</i>"));
                    } else {
                        $backContent.append($("<p>").addClass("badge-description").text(value.description));
                    }

                    if(value.tags.length == 0){
                        $backContent.append("<p>No skills linked to badge.</p>");
                    } else {
                        $tags = $("<div class='badge-skills' />");
                        for(var i = 0; i < value.tags.length; i++) {
                            $tags.append($("<span>").addClass("flag flag--badged").text(value.tags[i]));
                        }
                        $backContent.append($tags);
                    }

                })
            .catch(
                // Log the rejection reason
                function(reason) {
                    console.error('Error retrieving badge details.', reason);
                });

        }


    });

    oThis.SubmissionStore = Reflux.createStore({
        listenables: oThis.Actions,
        submissionstore: [],

        init: function() {
            //this.onFetchProgram();
        },

        getInitialState: function() {
            this.onFetchSubmissions();
        },

        onFetchSubmissions: function() {
            var oStore = this;
            var endpoint = buildRoute(mantlroutes.program_submissions,{ orgid: oThis.settings.orgID, programid: oThis.settings.programID });
            if(oThis.settings.view_mode && oThis.settings.program_role_id > 0) {
                endpoint += formatParams({ learner: oThis.settings.program_role_id }); //filter to just one learner when in view mode
            }
            httpGet(endpoint).then(
                function(value) {
                    //console.log(JSON.parse(value))
                    oStore.submissionstore = JSON.parse(value);
                    oStore.trigger(oStore.submissionstore);
                })
            .catch(
                function(reason) {
                    console.error('Error loading submissions.', reason);
                });

        }

    });

    oThis.AssessmentStore = Reflux.createStore({
        listenables: oThis.Actions,
        assessmentstore: [],

        init: function() {
            //this.onFetchProgram();
        },

        getInitialState: function() {
            this.onFetchAssessments();
        },

        onFetchAssessments: function() {
            var oStore = this;
            var endpoint = buildRoute(mantlroutes.program_assessments,{ orgid: oThis.settings.orgID, programid: oThis.settings.programID });
            if(oThis.settings.view_mode && oThis.settings.program_role_id > 0) {
                endpoint += formatParams({ learner: oThis.settings.program_role_id }); //filter to just one learner when in view mode
            }

            httpGet(endpoint).then(
                function(value) {
                    //console.log(JSON.parse(value))
                    oStore.assessmentstore = JSON.parse(value);
                    oStore.trigger(oStore.assessmentstore);
                })
            .catch(
                function(reason) {
                    console.error('Error loading assessments.', reason);
                });

        }

    });

    oThis.EarnedBadgeStore = Reflux.createStore({
        listenables: oThis.Actions,
        earnedbadgestore: [],

        init: function() {
            //this.onFetchProgram();
        },

        getInitialState: function() {
            this.onFetchEarnedBadges();
        },

        onFetchEarnedBadges: function() {

            var oStore = this;
            if(!oThis.settings.view_mode) {
                httpGet(buildRoute(mantlroutes.portfolio_badges,{ portfolioid: oThis.settings.portfolio_user })).then(
                    function(value) {
                        //console.log('earned store',JSON.parse(value))
                        oStore.earnedbadgestore = JSON.parse(value);
                        oStore.trigger(oStore.earnedbadgestore);
                    })
                .catch(
                    function(reason) {
                        console.error('Error loading earned badges.', reason);
                    });
            } else {
                oStore.earnedbadgestore = [];
                oStore.trigger(oStore.earnedbadgestore);
            }

        }

    });



}
